import { render, staticRenderFns } from "./companyReferred.vue?vue&type=template&id=af91a5a6&scoped=true"
import script from "./companyReferred.vue?vue&type=script&lang=js"
export * from "./companyReferred.vue?vue&type=script&lang=js"
import style0 from "./companyReferred.vue?vue&type=style&index=0&id=af91a5a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af91a5a6",
  null
  
)

export default component.exports